import CoreBase from '../../../../../services/engines/CoreBase';
import iframeController from '../IframeController';
import entryUpdater from '../EntryUpdater';

class UpdateEmsHandler extends CoreBase {
    _name = 'UpdateEmsHandler';

    /**
     * Handles jerny:updateems — replaces ems on an existing entry (e.g. after time edit) and persists.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     * @param {object} entry
     */
    handle = (e, iframe, entry) => {
        try {
            if (e.source !== iframe?.contentWindow) return;

            const { oldEms, newEms } = e.data ?? {};
            if (!oldEms || !newEms) return;

            const body = iframeController.parseBody(entry);
            if (!body) return;

            const item = body.userInput?.find(i => i.ems === oldEms);
            if (!item) return;

            item.ems = newEms;

            entryUpdater.update(entry, body);
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const updateEmsHandler = new UpdateEmsHandler();
export default updateEmsHandler;
